import axios from 'axios';

let BASE_URL = process.env.REACT_APP_INT_URL;

const zirveNovaRequest = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

const loginZirveNova = async (username, password) => {
    return await zirveNovaRequest.post('/zirvenova-defter/login', { username, password });
};

export { loginZirveNova };
